import { render } from "./candidateList.vue?vue&type=template&id=0a9ff614"
import script from "./candidateList.vue?vue&type=script&lang=js"
export * from "./candidateList.vue?vue&type=script&lang=js"

import "./candidateList.vue?vue&type=style&index=0&id=0a9ff614&lang=less"

import exportComponent from "/root/.jenkins/workspace/embeddedJobWebProd/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__